videoSizing();
$(window).on('resize', function () { videoSizing(); });

function videoSizing() {
    $('figure.iframe-video').each(function () {
        let iframe = $(this).find('iframe'),
            ratio = iframe.attr('height') / iframe.attr('width');

        $(this).css('padding-bottom', ratio * 100 + '%');
    });
}

$('.video-modal').on('hidden.bs.modal', function (e) {
    let iframes = $(this).find('iframe'),
        iframe = iframes[0];

    stopIframe(iframe);
});

function stopIframe(iframe) {
    var newSrc = iframe.src;
    newSrc = newSrc.replace('&autoplay=1', '');
    iframe.src = newSrc;
}